module.exports = __webpack_public_path__ + "img/goals1.5c11912b.svg";